import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import {
  STATIC_DATA,
  STATIC_JSON_DATA_PATH,
} from '../../../../shared/constants/static-data.constants';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ClaimsService } from '../../../../services/claims.service';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { BillingService } from '../../../../services/billing.service';
import { ListService } from '../../../../shared/services/list.service';
import { DatePipe } from '@angular/common';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { UserService } from '../../../../services/user.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SectionsService } from '../../../../services/sections.service';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import {
  DialogConfig,
  DialogService,
} from '../../../../shared/services/dialog.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ppl-recon-files-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent, FormsModule],
  templateUrl: './workday-status-list.component.html',
  styleUrl: './workday-status-list.component.css',
})
export class WorkdayStatusListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_RECON_FILES_DATA;
  pageId: string = PAGE_CONSTANTS.RECON_FILES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;
  appliedFilters: any;
  workdayList: any[] = [];
  selectedRowData: any;
  selectedServiceCode: any;
  actionButtons: TableRowActionsModel = new TableRowActions({ edit: true });
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  private dialogSvc = inject(DialogService);
  @ViewChild('serviceDialog') serviceDialog!: TemplateRef<any>;

  fields = [
    { field: 'serviceCode', show: true },
    { field: 'workdaySales', show: true },
  ];
  cols = [];

  constructor(
    private router: Router,
    private listService: ListService,
    private billingService: BillingService,
    private datePipe: DatePipe,
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private authService: AuthorizationService,
    private authUtility: AuthorizationUtility,
    private userService: UserService,
    private logger: LoggerService,
    private sectionService: SectionsService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.getInitData();
    this.getColumnData();
  }

  async getColumnData() {
    try {
      const tempCols = await this.sectionService.getJsonConfigurationData(
        STATIC_JSON_DATA_PATH.WORKDAY_STATUS_LIST_PAGE_HEADERS,
        'billing'
      );
      this.cols = tempCols.columns;
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  getInitData() {
    this.searchWorkdayList([]);
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchWorkdayList(filters);
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchWorkdayList(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.workdayList = [];
    }
    const processedPayload = this.buildRequestPayload(
      'billing-workday-sales-list',
      'createddate',
      filters,
      startingPageNumber
    );
    this.listService
      .getListData(processedPayload, 'billing')
      .subscribe((data: any) => {
        const records = data.responsedata;
        records.forEach((element: any) => {
          element.createddate = this.datePipe.transform(
            element.createddate,
            'MM/dd/yyyy'
          );
        });
        if (startingPageNumber > 1) {
          this.workdayList = [...this.workdayList, ...records];
          this.childComponent.resetPagination(startingPageNumber, currentPage);
        } else {
          this.workdayList = records;
        }
      });
  }

  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('billing');
    console.log('rowDetail', rowDetail);
  }

  onAction(event: any) {
    if (event.action === 'edit') {
      console.log(event.data);
      this.selectedRowData = event.data;
      this.selectedServiceCode = this.selectedRowData.workdaySales;
      this.openServiceDialog();
    }
  }

  openServiceDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Workday Sales',
      isOkText: 'Save',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.serviceDialog,
      dialogConfig,
      () => this.editServiceCode(),
      () => this.handleCancel()
    );
  }

  editServiceCode() {
    const payload = {
      salesId: this.selectedRowData.salesId,
      serviceCode: this.selectedRowData.serviceCode,
      modifierCode: this.selectedRowData.modifierCode,
      serviceType: this.selectedRowData.serviceType,
      serviceDescription: this.selectedRowData.serviceDescription,
      workdaySales: this.selectedServiceCode,
      programCode: this.programName,
    };
    console.log('changed', payload);
    this.billingService.saveWorkdaySales(payload).subscribe((data: any) => {
      console.log(data);
      this.searchWorkdayList([]);
    });
  }

  handleCancel() {}

  onPageLoad(event: any) {
    this.searchWorkdayList(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
